import { L } from '@angular/cdk/keycodes';
import { DatePipe } from '@angular/common';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { VG_DATE_PROVIDERS, VgModernDatepickerDirective } from '../../vg-datepicker/vg-datepicker';

/**
 * One icon per health device, shared by every Health dialog / list that shows a device.
 * Same Font Awesome glyphs the "Add Manual Devices" dropdown already used (tint, lungs, heartbeat, weight,
 * thermometer); only the per-device colours are gone - the colour comes from the shared `.hd-dev-i` class
 * (the Health Dashboard blue). Keyed by the existing device systemId.
 */
export const HEALTH_DEVICE_ICONS: { [systemId: string]: string } = {
  '0x1808': 'fas fa-tint',             // Blood Glucose
  '0x1822': 'fas fa-lungs',            // Blood Oxygen
  '0x1810': 'fas fa-heartbeat',        // Blood Pressure
  '0x181D': 'fas fa-weight',           // Weight
  '0x1809': 'fas fa-thermometer-half'  // Temperature
};

/** Class list for the device's icon element, or '' when the device is unknown (callers then keep their old image). */
export function healthDeviceIcon(systemId?: string | null): string {
  const glyph = systemId ? HEALTH_DEVICE_ICONS[systemId] : '';
  return glyph ? `${glyph} hd-dev-i` : '';
}

@Component({
    selector: 'app-devices',
    templateUrl: './devices.component.html',
    styleUrls: ['./devices.component.css'],
    standalone: false
})
export class DevicesComponent {

  /** Shared device icon classes (see health-device-icons.ts); '' for an unknown device. */
  deviceIcon(systemId?: string | null): string {
    return healthDeviceIcon(systemId);
  }

  added_devices:any;
  searchText: string = '';
   update_dr: any;
  device_names = [
    {title: 'Blood Glucose',data_type: 'single', unit: {title: ['Blood Glucose'], unit: ['mg/dl']}, device_type: 'BGDEVICE', systemId: '0x1808' , image: 'assets/images/health/devices/bgdevice.svg', category: 2, flag: false}, 
    {title: 'Blood Oxygen', data_type: 'single', unit: {title: ['Blood Oxygen'], unit: ['SpO2%']}, device_type: 'PULSEDEVICE', systemId: '0x1822',  image: 'assets/images/health/devices/pulsedevice.svg', category: 4, flag: false}, 
    {title: 'Blood Pressure', data_type: 'three', unit: {title: ['Systolic', 'Diastolic', 'Pulse'], unit: ['mm Hg','mm Hg', 'bpm']}, device_type: 'BPDEVICE', systemId: '0x1810',  image: 'assets/images/health/devices/bpdevice.svg', category: 3, flag: false}, 
    {title:  'Weight', data_type: 'single', unit: {title: ['Weight'], unit: ['Kg']}, device_type: 'WEIGHSCALEDEVICE', systemId: '0x181D', image: 'assets/images/health/devices/weightdevice.svg', category: 6, flag: false}, 
    {title: 'Temperature', data_type: 'single', unit: {title: ['Temperature'], unit: ['Fahrenheit']}, device_type: 'THERMODEVICE', systemId: '0x1809', image: 'assets/images/health/devices/tempdevice.svg', category: 5, flag: false}
  ]
  isUploading = false;

  constructor(private dialog: MatDialog,  private toastr: ToastrService,
        private router: Router,
        private sanitizer: DomSanitizer,
        private auth: AuthService,
       ){}

  
  ngOnInit(){
    this.getDevices()
    this.get_latest_reading()

  }

  AddDevices(){

  }

  get_latest_reading() {
  this.auth.lastest_device_reading().subscribe((res: any) => {
    if (res.error === false) {
      const readings = res.data.devicelatestreading;

      this.update_dr.forEach((device: any) => {
        const matchedReading = readings.find((r: any) => r.device.id === device.id);

        if (matchedReading) {
          device.value1 = matchedReading.value1;
          device.value2 = matchedReading.value2;
          device.value3 = matchedReading.value3;
          device.readingDateTime = matchedReading.readingDateTime;
          device.valueUnit1 = matchedReading.valueUnit1;
          device.valueUnit2 = matchedReading.valueUnit2;
          device.valueUnit3 = matchedReading.valueUnit3;
          device.recordedDateTime = matchedReading.recordedDateTime;
          device.type = matchedReading.type;
        }
      });

      // Sort devices: ones with readingDateTime first
      this.update_dr.sort((a: any, b: any) => {
        const aHasReading = !!a.readingDateTime;
        const bHasReading = !!b.readingDateTime;

        // true sorts before false => descending order
        if (aHasReading && !bHasReading) return -1;
        if (!aHasReading && bHasReading) return 1;
        return 0;
      });
      this.isUploading = false;

      //console.log('Sorted update_dr (readings first):', this.update_dr);
    }
  },
    (err: any) => {

      this.isUploading = false; // ensure spinner cleared on error
    });
}



  getDevices() {
    this.isUploading = true;
    this.auth.device_list().subscribe((res: any) => {
      if (res.error == false) {
        this.added_devices = res.data.device
        this.update_dr = this.added_devices;
        //console.log('Updated Devices:', this.update_dr);
        this.update_dr.forEach((element: any) => {
          this.device_names.forEach(item => {
            if (item.systemId == element.systemId) {
              element['image'] = item.image;
              element['title'] = item.title;
              // //console.log(element['image'])
            }
          });
        });
        //console.log(this.update_dr)
      } else{
        this.isUploading = false;
      }
      this.get_latest_reading();
    },
    (err: any) => {
    
      this.isUploading = false; // ensure spinner cleared on error
    })
   
  }
//   formattedDateTime(item:any): string {
//   const readingDate = new Date(item);
//   const now = new Date();

//   // Clear time for both dates
//   const readingDay = new Date(readingDate.getFullYear(), readingDate.getMonth(), readingDate.getDate());
//   const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

//   const msInDay = 86400000;
//   const diffDays = (today.getTime() - readingDay.getTime()) / msInDay;

//   const time = readingDate.toLocaleTimeString([], {
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: true,
//   });

//   if (diffDays === 0) {
//     return `Today · ${time}`;
//   } else if (diffDays === 1) {
//     return `Yesterday · ${time}`;
//   } else {
//     const formattedDate = readingDate.toLocaleDateString('en-GB'); // e.g., 30/07/2025
//     return `${formattedDate} · ${time}`;
//   }
// }

formattedDateTime(item: any): string {
  const readingDate = new Date(item);
  const now = new Date();

  // Check if the date is today
  const isToday =
    readingDate.getDate() === now.getDate() &&
    readingDate.getMonth() === now.getMonth() &&
    readingDate.getFullYear() === now.getFullYear();

  let formattedDate: string;

  if (isToday) {
    formattedDate = 'Today';
  } else {
    // Show weekday + date (e.g., Sunday, 22 September 2025)
    formattedDate = readingDate.toLocaleDateString('en-US', {
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }

  // Format time (e.g., 06:05 PM)
  const formattedTime = readingDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${formattedDate} | ${formattedTime}`;
}

    openDialog(){
          // "+ Add Vitals": device cards + reading form in one modal (onEdit / Add Reading below keep their own dialog)
          const dialogRef = this.dialog.open(AddVitalsComponent, {
            width: '600px',
            maxWidth: '95vw',
            disableClose: true,
            autoFocus: false,
          
          });
      
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.getDevices()
            }
          });
         }
    
  

  onEdit(item: any) {
    // console.log(item)
     const dialogRef = this.dialog.open(AddDeviceReadingComponent, {
            width: '600px',
            data: { 
              details: item
            },
            disableClose: true,
            autoFocus: false,
          
          });
      
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.getDevices();
            }
          });

  }

  onDelete(item: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: {
      title: 'Delete Device',
      message: `Are you sure want to delete this device?`,
      sub: 'You will not be able to recover it once it is deleted.'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && item) {
        this.auth.delete_device2(item.id).subscribe(
          (res: any) => {
            if (res.error === false) {
              this.toastr.success(res.msg);
              this.getDevices();
            }
          },
          error => {
            console.error('Error deleting device:', error);
            this.toastr.error('Failed to delete device');
          }
        );
      }
    });
  }

  
  goBack(): void {
    this.router.navigate(["/health/dashbord"])
  }

}


@Component({
    templateUrl: './add-devices.html',
    styleUrls: ['./devices.component.css', './add-vitals.css'],
    standalone: false
})
export class AddDevicesComponent {

  /** Shared device icon classes (see health-device-icons.ts); '' for an unknown device. */
  deviceIcon(systemId?: string | null): string {
    return healthDeviceIcon(systemId);
  }

  selectedDevice:any;
  reg_devices:any;
    device_names = [
    {title: 'Blood Glucose',data_type: 'single', unit: {title: ['Blood Glucose'], unit: ['mg/dl']}, device_type: 'BGDEVICE', systemId: '0x1808' , image: ['fas fa-tint', 'color: #f75b5b'], category: 2, flag: false}, 
    {title: 'Blood Oxygen', data_type: 'single', unit: {title: ['Blood Oxygen'], unit: ['SpO2%']}, device_type: 'PULSEDEVICE', systemId: '0x1822',  image: ['fas fa-lungs', 'color: #4c7dfe'], category: 4, flag: false}, 
    {title: 'Blood Pressure', data_type: 'three', unit: {title: ['Systolic', 'Diastolic', 'Pulse'], unit: ['mm Hg','mm Hg', 'bpm']}, device_type: 'BPDEVICE', systemId: '0x1810',  image: ['fas fa-heartbeat', 'color: #ed3b3b'], category: 3, flag: false}, 
    {title:  'Weight', data_type: 'single', unit: {title: ['Weight'], unit: ['Kg']}, device_type: 'WEIGHSCALEDEVICE', systemId: '0x181D', image: ['fas fa-weight', 'color: #52b8c4'], category: 6, flag: false}, 
    {title: 'Temperature', data_type: 'single', unit: {title: ['Temperature'], unit: ['Fahrenheit']}, device_type: 'THERMODEVICE', systemId: '0x1809', image: ['fa fa-thermometer-half', 'color: #f9f44f'], category: 5, flag: false}
  ]
  mode: 'add' | 'edit' = 'add';
  submitted = false
 
  
  constructor(
    private fb: FormBuilder,
    private auth:AuthService,
    public datepipe:DatePipe,
     private toastr: ToastrService,
    private dialogRef: MatDialogRef<AddDevicesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.mode = data?.mode === 'edit' ? 'edit' : 'add';


  }

  

  ngOnInit(): void {
    
   this.auth.device_list().subscribe((res: any) => {
    if (res.error === false) {
      this.reg_devices = res.data.device;

      // Create a Set of systemIds for fast lookup
      const registeredSystemIds = new Set(this.reg_devices.map((d: any) => d.systemId));

        // Filter device_names to remove already registered devices
        this.device_names = this.device_names.filter(item => !registeredSystemIds.has(item.systemId));
      }
    });

    //console.log(this.device_names)
  }

   

  



 generateId(prefix: string = ''): string {
  return prefix + Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
}

  onSave(): void {
    //console.log(this.selectedDevice)
     this.submitted = true

      // //console.log(id);
        let name = `Device-${this.generateId()}`;
        let manufacturer = `Vendor-${this.generateId()}`;
        let category = 0;
        let serviceUid = this.generateId('svc-');
        let systemId = '';
        let modelNumber = Math.floor(1000 + Math.random() * 9000);
        let serialNumber = Math.floor(100000 + Math.random() * 900000);
        let isBLE = true;
        let paired = false;
        let status = 'OFFLINE';

        this.device_names.forEach(item => {
          if(item.title == this.selectedDevice.title){
            category = item.category;
            systemId = item.systemId;            
          }
        });

    this.auth.add_new_device(name, category, serviceUid, manufacturer, systemId, modelNumber, serialNumber, isBLE, paired, status).subscribe((res: any) => {
          this.toastr.success(res.msg);
          this.dialogRef.close(this.selectedDevice);
         
  })
}

  onCancel(): void {
    this.dialogRef.close();
  }
}



@Component({
    templateUrl: './add-device-reading.html',
    styleUrls: ['./devices.component.css', './add-vitals.css'],
    providers: VG_DATE_PROVIDERS,   // dates display as "Oct 13, 2026"
    standalone: false
})
export class AddDeviceReadingComponent {

  /** Shared device icon classes (see health-device-icons.ts); '' for an unknown device. */
  deviceIcon(systemId?: string | null): string {
    return healthDeviceIcon(systemId);
  }

  selectedDevice:any;
  reg_devices:any;
   device_names = [
    {title: 'Blood Glucose',data_type: 'single', unit: {title: ['Blood Glucose'], unit: ['mg/dl']}, device_type: 'BGDEVICE', systemId: '0x1808' , image: 'assets/images/health/devices/bgdevice.svg', category: 2, flag: false}, 
    {title: 'Blood Oxygen', data_type: 'single', unit: {title: ['Blood Oxygen'], unit: ['SpO2%']}, device_type: 'PULSEDEVICE', systemId: '0x1822',  image: 'assets/images/health/devices/pulsedevice.svg', category: 4, flag: false}, 
    {title: 'Blood Pressure', data_type: 'three', unit: {title: ['Systolic', 'Diastolic', 'Pulse'], unit: ['mm Hg','mm Hg', 'bpm']}, device_type: 'BPDEVICE', systemId: '0x1810',  image: 'assets/images/health/devices/bpdevice.svg', category: 3, flag: false}, 
    {title:  'Weight', data_type: 'single', unit: {title: ['Weight'], unit: ['Kg']}, device_type: 'WEIGHSCALEDEVICE', systemId: '0x181D', image: 'assets/images/health/devices/weightdevice.svg', category: 6, flag: false}, 
    {title: 'Temperature', data_type: 'single', unit: {title: ['Temperature'], unit: ['Fahrenheit']}, device_type: 'THERMODEVICE', systemId: '0x1809', image: 'assets/images/health/devices/tempdevice.svg', category: 5, flag: false}
  ]
  mode: 'add' | 'edit' = 'add';
  details:any;
  form: any;
  categoryType: string = '';
  submitted = false
  valueUnit1 = '';
  valueUnit2 = '';
  valueUnit3 = '';
  mealTypes :any [
  ]=[];
  tag_id=1;
  tag_list:any;
  selectedMeal: string = 'fasting';
  maxDate = new Date();
  
  constructor(
    private fb: FormBuilder,
    private auth:AuthService,
    public datepipe:DatePipe,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<AddDevicesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {
    this.details = data?.details;
    this.dialogRef.updateSize('680px');   // same width as the Add Vitals dialog, room for the one-row timing options
  }

  /** Validation message visibility (touched field or a save attempt), as mat-error used to decide. */
  showError(name: string): boolean {
    const control = this.form?.get(name);
    return !!control && control.invalid && (control.touched || this.submitted);
  }
  

  ngOnInit(): void {
    console.log(this.details)
    this.categoryType = this.details?.title || this.details?.category?.name || '';

    // Set units based on category
    switch (this.categoryType) {
      case 'Weight':
        this.valueUnit1 = 'kg';
        break;
      case 'Blood Glucose':
        this.valueUnit1 = 'mg/dL';
        break;
      case 'Blood Pressure':
        this.valueUnit1 = 'mmHg';
        this.valueUnit2 = 'mmHg';
        this.valueUnit3 = 'bpm';
        break;
      case 'Blood Oxygen':
        this.valueUnit1 = 'SpO2%';
        break;
      case 'Temperature':
        this.valueUnit1 = 'Fahrenheit';
        break;


    }
   

  //console.log(this.details)
  this.getTags()
  this.buildForm()
   
  }

  selectMeal(meal:any){
    this.selectedMeal = meal.key;
    this.tag_id = meal.id;

  }

  getTags() {
  let id: any;

  this.auth.get_category("DEVICE").subscribe((res: any) => {
    if (!res?.data?.device) return;

    const matchedDevice = res.data.device.find((d: any) => d.subtype === 'BGDEVICE');
    if (!matchedDevice) return;

    id = matchedDevice.id;

    this.auth.get_tag_list(id).subscribe((res: any) => {
      if (!res?.data?.tag) return;
      
      this.tag_list = res.data.tag;
     //console.log(this.tag_list)
      const iconMap: any = {
        fasting: 'assets/images/health/homeimg/exandcareplan/breakfast.png',
        before_meal: 'assets/images/health/homeimg/exandcareplan/lunch.png',
        after_meal: 'assets/images/health/homeimg/exandcareplan/dinner.png',
        before_sleep: 'assets/images/health/icons/carbon_asleep-filled.svg',
        general: 'assets/images/health/homeimg/exandcareplan/break.png',
      };

      this.mealTypes = this.tag_list.map((tag: any) => {
        const key = tag.shortText?.toLowerCase() || '';
        return {
          id: tag.id,
          label: tag.description,
          key,
          icon: iconMap[key]  || 'assets/images/icons/default.png',
        };
      });
    });
  });
}

  buildForm() {
    const isBP = this.categoryType === 'Blood Pressure';

    this.form = this.fb.group({
      value1: ['', [Validators.required, Validators.max(999), Validators.min(11)]],
      value2: ['', isBP ? [Validators.required, Validators.max(999), Validators.min(11)] : []],
      value3: ['', isBP ? [Validators.required, Validators.max(999), Validators.min(11)] : []],
      readingDate: [new Date(), Validators.required],
      readingTime: [this.getCurrentTime(), Validators.required],
      comment: ['']
    });
  }

  get f() {
    return this.form.controls;
  }

  preventNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  preventPasteNegative(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    if (pastedInput.includes('-') || pastedInput.includes('+')) {
      event.preventDefault();
    }
  }

  getCurrentTime(): string {
    const now = new Date();
    return now.toTimeString().slice(0, 5); // "HH:mm"
  }
  
  formatReadingDateTime(): string {
    const date = this.form.value.readingDate;
    const time = this.form.value.readingTime;

    const [hourStr, minutePart] = time.split(':');
    const [minute, period] = minutePart.split(' ');
    const h = parseInt(hourStr, 10);
    const m = minute.padStart(2, '0');
    const suffix = period.toUpperCase();

    const formattedDate = new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    }).format(date);

    return `${formattedDate.replace(/\//g, '-')} ${h}:${m} ${suffix}`;
  } 

  getChange(controlName: string) {
    const control = this.form.get(controlName);
    if (control) {
      control.markAsTouched({ onlySelf: true }); // show validation immediately
    }
  }

  preventNonNumeric(event: KeyboardEvent) {
  if (
    event.key &&
    !/^\d$/.test(event.key) &&
    event.key !== 'Backspace' &&
    event.key !== 'Tab' &&
    event.key !== 'ArrowLeft' &&
    event.key !== 'ArrowRight'
  ) {
    event.preventDefault();
  }
}

preventPasteNonNumeric(event: ClipboardEvent) {
  const pasted = event.clipboardData?.getData('text');
  if (pasted && !/^\d+$/.test(pasted)) {
    event.preventDefault();
  }
}


  onSubmit(): void {
     this.submitted = true
     
     if (this.form.invalid) {
      //this.form.markAllAsTouched();
      return;
    }

    const formValue = this.form.value;
    console.log(formValue)
    const date = this.datepipe.transform(formValue.readingDate, 'MM-dd-yyyy');
    const time = this.datepipe.transform(`1970-01-01T${formValue.readingTime}`, 'hh:mm a');        
    const datetime = `${date} ${time}`;
    //console.log(formValue)
    let payload = {
      device: this.details.id,
      sequence: 0,
      readingDateTime: datetime,
      value1: formValue.value1,
      value2: this.categoryType === 'Blood Pressure' ? formValue.value2 : 0,
      value3: this.categoryType === 'Blood Pressure' ? formValue.value3 : 0,
      valueUnit1: this.valueUnit1,
      valueUnit2: this.valueUnit2,
      valueUnit3: this.valueUnit3
    };

    if(formValue.value2 === '' || formValue.value2 === null || formValue.value2 === undefined){
      formValue.value2 = 0;
    }
    if(formValue.value3 === '' || formValue.value3 === null || formValue.value3 === undefined){
      formValue.value3 = 0;
    }

    //console.log('Final Payload:', payload);
    this.auth.add_device_reading(this.details.id, 0, datetime, Number(formValue.value1), formValue.value2, formValue.value3, this.valueUnit1, this.valueUnit2, this.valueUnit3, this.tag_id).subscribe((res: any) => {
      if (res.error == false) {
        this.toastr.success(res.msg)
        this.reGetDevices();
        this.dialogRef.close();
      }
    })
}

  reGetDevices() {
    const currentUrl = this.router.url; this.router.navigateByUrl('/', {
      skipLocationChange: true
    }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}


/**
 * "Add Vitals": choose a device card and enter its reading in the same modal.
 * Opened from the Health Dashboard (Add Vitals / Vitals "+") and from Vitals ("+ Add Vitals").
 * A device that is not registered yet is registered first (same call as AddDevicesComponent), then the reading
 * is saved with the existing add_device_reading call (same payload and validation as AddDeviceReadingComponent).
 */
@Component({
    templateUrl: './add-vitals.html',
    styleUrls: ['./devices.component.css', './add-vitals.css'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatDatepickerModule, VgModernDatepickerDirective],
    providers: [DatePipe, ...VG_DATE_PROVIDERS]   // dates display as "Oct 13, 2026"
})
export class AddVitalsComponent {

  /** Shared device icon classes (see health-device-icons.ts); '' for an unknown device. */
  deviceIcon(systemId?: string | null): string {
    return healthDeviceIcon(systemId);
  }

  // same devices, system ids, categories, icons and units as the existing reading dialog
  readonly devices = [
    { title: 'Blood Glucose', systemId: '0x1808', category: 2, image: 'assets/images/health/devices/bgdevice.svg',     valueUnit1: 'mg/dL',      valueUnit2: '',      valueUnit3: '' },
    { title: 'Blood Oxygen',  systemId: '0x1822', category: 4, image: 'assets/images/health/devices/pulsedevice.svg',  valueUnit1: 'SpO2%',      valueUnit2: '',      valueUnit3: '' },
    { title: 'Blood Pressure',systemId: '0x1810', category: 3, image: 'assets/images/health/devices/bpdevice.svg',     valueUnit1: 'mmHg',       valueUnit2: 'mmHg',  valueUnit3: 'bpm' },
    { title: 'Weight',        systemId: '0x181D', category: 6, image: 'assets/images/health/devices/weightdevice.svg', valueUnit1: 'kg',         valueUnit2: '',      valueUnit3: '' },
    { title: 'Temperature',   systemId: '0x1809', category: 5, image: 'assets/images/health/devices/tempdevice.svg',   valueUnit1: 'Fahrenheit', valueUnit2: '',      valueUnit3: '' }
  ];

  selected: any = null;
  form: FormGroup | null = null;
  isSaving = false;
  attempted = false;   // a save was tried: show every validation message
  maxDate = new Date();

  // Blood Glucose "when did you check?" (same defaults as the existing dialog)
  mealTypes: any[] = [];
  selectedMeal = 'fasting';
  tagId = 1;
  private tagsLoaded = false;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private datepipe: DatePipe,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<AddVitalsComponent>,
    private router: Router
  ) {
    this.dialogRef.updateSize('680px');   // room for the compact one-row "When did you check?" options
  }

  select(device: any): void {
    if (this.isSaving || this.selected?.systemId === device.systemId) { return; }
    this.selected = device;
    this.attempted = false;
    this.selectedMeal = 'fasting';   // nothing is carried over from the previous device
    this.tagId = 1;
    this.buildForm();
    if (device.title === 'Blood Glucose' && !this.tagsLoaded) { this.getTags(); }
  }

  selectMeal(meal: any): void {
    this.selectedMeal = meal.key;
    this.tagId = meal.id;
  }

  /** Roving tabindex: the selected option (or the first one when nothing matches) is the tab stop of the group. */
  mealTabIndex(index: number): number {
    const hasSelected = this.mealTypes.some(m => m.key === this.selectedMeal);
    return (hasSelected ? this.mealTypes[index].key === this.selectedMeal : index === 0) ? 0 : -1;
  }

  /** Arrow keys move the selection through the options (radio-group behaviour). */
  onMealKey(event: KeyboardEvent, index: number): void {
    const count = this.mealTypes.length;
    let next = index;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') { next = (index + 1) % count; }
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') { next = (index - 1 + count) % count; }
    else { return; }
    event.preventDefault();
    this.selectMeal(this.mealTypes[next]);
    setTimeout(() => document.getElementById('vd-meal-' + next)?.focus());
  }

  /** Validation message of a field (same texts as before) once it was touched or a save was attempted; '' otherwise. */
  fieldError(name: string): string {
    const control = this.form?.get(name);
    if (!control || !control.invalid || !(control.touched || this.attempted)) { return ''; }
    if (control.hasError('required')) { return 'This field is required'; }
    if (control.hasError('min')) { return 'Value must be greater than 10'; }
    if (control.hasError('max')) { return 'Value must be less than 999'; }
    return '';
  }

  private buildForm(): void {
    const isBP = this.selected?.title === 'Blood Pressure';
    this.form = this.fb.group({
      value1: ['', [Validators.required, Validators.max(999), Validators.min(11)]],
      value2: ['', isBP ? [Validators.required, Validators.max(999), Validators.min(11)] : []],
      value3: ['', isBP ? [Validators.required, Validators.max(999), Validators.min(11)] : []],
      readingDate: [new Date(), Validators.required],
      readingTime: [new Date().toTimeString().slice(0, 5), Validators.required],
      comment: ['']
    });
  }

  /** Meal timing tags (same calls as the existing reading dialog). */
  private getTags(): void {
    this.auth.get_category('DEVICE').subscribe((res: any) => {
      const matchedDevice = res?.data?.device?.find((d: any) => d.subtype === 'BGDEVICE');
      if (!matchedDevice) { return; }
      this.auth.get_tag_list(matchedDevice.id).subscribe((tags: any) => {
        if (!tags?.data?.tag) { return; }
        const iconMap: any = {
          fasting: 'assets/images/health/homeimg/exandcareplan/breakfast.png',
          before_meal: 'assets/images/health/homeimg/exandcareplan/lunch.png',
          after_meal: 'assets/images/health/homeimg/exandcareplan/dinner.png',
          before_sleep: 'assets/images/health/icons/carbon_asleep-filled.svg',
          general: 'assets/images/health/homeimg/exandcareplan/break.png',
        };
        this.mealTypes = tags.data.tag.map((tag: any) => {
          const key = tag.shortText?.toLowerCase() || '';
          return { id: tag.id, label: tag.description, key, icon: iconMap[key] || 'assets/images/icons/default.png' };
        });
        this.tagsLoaded = true;
      });
    });
  }

  getChange(controlName: string): void {
    this.form?.get(controlName)?.markAsTouched({ onlySelf: true });   // show validation immediately
  }

  preventNonNumeric(event: KeyboardEvent): void {
    if (event.key && !/^\d$/.test(event.key) && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Enter'].includes(event.key)) {
      event.preventDefault();
    }
  }

  preventPasteNonNumeric(event: ClipboardEvent): void {
    const pasted = event.clipboardData?.getData('text');
    if (pasted && !/^\d+$/.test(pasted)) { event.preventDefault(); }
  }

  // ----- device lookup / registration -----

  private findDeviceId(systemId: string): Observable<any> {
    return this.auth.device_list().pipe(map((res: any) => {
      const list: any[] = res?.error === false ? (res?.data?.device || []) : [];
      return list.find(d => d.systemId === systemId)?.id || '';
    }));
  }

  private generateId(prefix: string = ''): string {
    return prefix + Date.now().toString(36) + Math.random().toString(36).substring(2, 8);
  }

  /** Same registration call and values as AddDevicesComponent.onSave(). */
  private registerDevice(device: any): Observable<any> {
    return this.auth.add_new_device(
      `Device-${this.generateId()}`, device.category, this.generateId('svc-'), `Vendor-${this.generateId()}`, device.systemId,
      Math.floor(1000 + Math.random() * 9000), Math.floor(100000 + Math.random() * 900000), true, false, 'OFFLINE');
  }

  /** Id of the device for the selected card; registers it first when the user does not have it yet. */
  private resolveDeviceId(device: any): Observable<any> {
    return this.findDeviceId(device.systemId).pipe(
      switchMap(id => id ? of(id) : this.registerDevice(device).pipe(switchMap(() => this.findDeviceId(device.systemId))))
    );
  }

  // ----- save -----

  onSubmit(): void {
    if (this.isSaving || !this.selected || !this.form) { return; }
    this.attempted = true;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const device = this.selected;
    const fv = this.form.value;
    const date = this.datepipe.transform(fv.readingDate, 'MM-dd-yyyy');
    const time = this.datepipe.transform(`1970-01-01T${fv.readingTime}`, 'hh:mm a');
    const datetime = `${date} ${time}`;
    const value2 = (fv.value2 === '' || fv.value2 === null || fv.value2 === undefined) ? 0 : fv.value2;
    const value3 = (fv.value3 === '' || fv.value3 === null || fv.value3 === undefined) ? 0 : fv.value3;

    this.isSaving = true;
    this.resolveDeviceId(device).pipe(
      switchMap(id => id
        ? this.auth.add_device_reading(id, 0, datetime, Number(fv.value1), value2, value3,
            device.valueUnit1, device.valueUnit2, device.valueUnit3, this.tagId)
        : of(null))
    ).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        if (res === null) {
          this.toastr.error('Could not set up this device. Please try again.');
        } else if (res.error == false) {
          this.toastr.success(res.msg);
          this.reGetDevices();
          this.dialogRef.close(true);
        }
      },
      error: () => { this.isSaving = false; }   // the existing http error handling reports the failure
    });
  }

  /** Refreshes the current page the same way the existing reading dialog does. */
  private reGetDevices(): void {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}